import { useCallback, useState } from 'react';

/**
 * Tracks selected IDs for a paginated list. Pass each row's id via `toggle`
 * or wire `toggleAll` to a header checkbox. Selection state is scoped to the
 * component instance — clearing on page change is opt-in via `clear`.
 */
export const useBulkSelection = () => {
  const [selected, setSelected] = useState(new Set());

  const toggle = useCallback((id) => {
    setSelected((prev) => {
      const next = new Set(prev);
      if (next.has(id)) next.delete(id);
      else next.add(id);
      return next;
    });
  }, []);

  const toggleAll = useCallback((ids, checked) => {
    setSelected((prev) => {
      const next = new Set(prev);
      if (checked) ids.forEach((id) => next.add(id));
      else ids.forEach((id) => next.delete(id));
      return next;
    });
  }, []);

  const clear = useCallback(() => setSelected(new Set()), []);

  const isSelected = useCallback((id) => selected.has(id), [selected]);

  return {
    selected,
    selectedIds: Array.from(selected),
    count: selected.size,
    toggle,
    toggleAll,
    clear,
    isSelected,
  };
};
